import DishBlock from './DishBlock'
import HeaderBlock from './HeaderBlock'
import PhotoBlock from './PhotoBlock'
import TextListBlock from './TextListBlock'
import React from 'react'

// block structure:
// id of the block for layout purposes
// type of the block for which react element to use
// linked to show if block content is elsewhere
// content of the block for display purposes

const BlockSwitch = ({block}) => {
  // console.log(block)
  switch (block.type) {
    case 'dish':
      return <DishBlock {...block.content} />
      break;
    case 'dish-text':
      return <DishBlock {...block.content} type="text" />
      break;
    case 'dish-image':
      return <DishBlock {...block.content} type="image" />
      break;
    case 'header':
      return <HeaderBlock {...block} />
      break;
    case 'photo':
      return <PhotoBlock {...block.content} />
      break;
    case 'text-list':
      return <TextListBlock {...block} />
      break;
    default:
      return <div>{JSON.stringify(block)}</div>
  }
}

export default BlockSwitch
